import { useHookstate } from '@hookstate/core';
import { I18n } from 'aws-amplify';
import classNames from "classnames";
import { Button } from "primereact/button";
import { Checkbox } from 'primereact/checkbox';
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { DataTable } from "primereact/datatable";
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown } from "primereact/dropdown";
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toolbar } from 'primereact/toolbar';
import React, { useContext, useEffect, useState } from 'react';
import { globalBlockedState, ToastContext } from '../../app-context';
import { helpState } from '../../help-context';
import { changeUserState, getMyTeam, saveOrCreateUser } from '../../service/CdmGlobalService.js';
import { MyStructuresContext, StructureContext } from '../../structure-context';
import { checkPhoneNumber, isEmail } from '../../Utils';
import { Help } from '../help/Help';
import { globalUserState, useGroupMember } from '../../user-context.js';
import { Tooltip } from 'primereact/tooltip';

const dummyTeam = Array.from({ length: 5 });

export const Team = () => {
    const blockedState = useHookstate(globalBlockedState);
    const structureContext = useContext(StructureContext);
    const structures = useContext(MyStructuresContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const toast = useContext(ToastContext);
    const [userDialog, setUserDialog] = useState(false);
    const [loading, setLoading] = useState(true);
    const [mailInUse, setMailInUse] = useState(false);
    const [usernameInUse, setUsernameInUse] = useState(false);
    // const [groupsCertificats,] = useState([{ id: 'certified', name: "Détenteur de certificat" }, { id: 'suivi_certificat', name: "Suivi des certificats" }]);
    const [groupsGeneriques] = useState([{ id: 'delegue', name: "Délégué" }]);
    const [groupsApprentissage,] = useState([{ id: 'superviseurs_apprentissage', name: "Superviseur Apprentissage" }]);
    const [groupsScrb, setGroupsScrb] = useState([]);
    const [myTeam, setMyTeam] = useState();
    const localUserState = useHookstate({});
    const localGroupsState = useHookstate([]);
    const [targetStructure, setTargetStructure] = useState();
    const [myTargetTeam, setMyTargetTeam] = useState([]);
    const [targetUser, setTargetUser] = useState();
    const help = useHookstate(helpState);
    const userData = useHookstate(globalUserState).get();
    const isGerant = useGroupMember("gerants");

    useEffect(() => {
        if (help.get()?.help !== Help.team) {
            help.set({ help: Help.team })
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const allGroups = ['scrb_mazout', 'scrb_gaz', 'scrb_clim', 'scrb_solide', 'scrb_pompe_chaleur'];
        if (userData) {
            const userGroupes = userData[`cdm-groups:${structureContext.id}`].split(" ");
            const filteredGroups = allGroups.filter(group => userGroupes.includes(group));
            setGroupsScrb(filteredGroups.map(group => ({ id: group })));
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let isSubscribed = true;

        const setInitialMyTeamCallBack = (_myTeam) => {
            if (isSubscribed) {
                setLoading(false);
                setMyTeam(_myTeam);
            }
        }
        if (structureContext.id) {
            getMyTeam(structureContext.id, setInitialMyTeamCallBack);
        }
        return () => (isSubscribed = false);
    }, [structureContext]);

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={classNames("customer-badge", "status-" + rowData.Enabled)}>
                {rowData.Enabled ? I18n.get("ACTIF") : I18n.get("DÉSACTIVÉ")}
            </span>
        );
    };

    const autoBodyTemplate = (rowData) => {
        return rowData.roles?.map((g, indexGroup) =>
            <div className="p-chip p-component mr-2 mb-2 cdm-extranet-chip" key={rowData.Username + "_" + indexGroup}><span className="p-chip-text">{I18n.get(g)}</span>
            </div>);
    };

    const editUser = (rowData) => {
        localUserState.set({ ...rowData });
        localGroupsState.set(JSON.parse(JSON.stringify(rowData.roles)));
        setMailInUse(false);
        setUsernameInUse(false);
        helpState.set({ help: Help.teammember })
        setUserDialog(true);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                {!rowData.roles?.includes('gerants') && (<>{rowData.Enabled && <Button icon="pi pi-user-edit" className="p-button-rounded p-button-success p-button-outlined mr-2" title={I18n.get("Modifier l'utilisateur")} onClick={(e) => editUser(rowData)} />}
                    {rowData.Enabled && <Button icon="fas fa-user-slash" className="p-button-rounded p-button-danger p-button-outlined " onClick={(e) => confirmChangeStatusUser(e, rowData)} title={I18n.get("Désactiver l'utilisateur")} />}
                    {!rowData.Enabled && <Button icon="fas fa-user-check" className="p-button-rounded p-button-success p-button-outlined " onClick={(e) => confirmChangeStatusUser(e, rowData)} title={I18n.get("Activer l'utilisateur")} />}
                </>)}
            </>
        );
    }

    const confirmChangeStatusUser = (event, _user) => {
        confirmPopup({
            target: event.currentTarget,
            message: !_user.Enabled ? `${I18n.get("Voulez-vous activer")} ${_user.given_name} ${_user.family_name}?` : `${I18n.get("Voulez-vous désactiver")} ${_user.given_name} ${_user.family_name}?`,
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: !_user.Enabled ? 'p-button-success' : 'p-button-danger',
            acceptLabel: I18n.get("Oui"),
            rejectLabel: I18n.get("Non"),
            accept: () => acceptChangeStatusUser(_user)
        });
    };

    const setMyTeamCallBack = (_myTeam) => {
        blockedState.set(false);
        setMyTeam(_myTeam);
    }

    const acceptChangeStatusUser = (_user) => {
        blockedState.set(true);
        changeUserState(structureContext.id, _user, setMyTeamCallBack)
    };

    const onChange = (event) => {
        localUserState[event.target.name].set(event.target.value);
    };

    const checkMail = () => {
        const _mail = localUserState.get().email ?? '';
        return !(isEmail(_mail));
    }

    const afterSaveCallback = (_myTeam, error, _user) => {
        blockedState.set(false);
        if (!error) {
            if (_myTeam) {
                setMyTeam(_myTeam);
                hideDialog();
            } else {
                localUserState.Username.set(_user.Username);
                setUsernameInUse(true);
                setActiveIndex(0);
            }
        } else if (error.status === 409) {
            if (toast && toast.current) {
                setTimeout(() => {
                    toast.current.show({ severity: 'error', summary: error.message, detail: I18n.get(error.message), life: 5000, closable: false });
                }, 0);
            }
            setMailInUse(true);
            setActiveIndex(0);
        } else {
            if (toast && toast.current) {
                setTimeout(() => {
                    toast.current.show({ severity: 'error', summary: error.message, detail: I18n.get(error.message), life: 5000, closable: false });
                }, 0);
            }
        }
    }

    const saveUser = () => {
        blockedState.set(true);
        localUserState.newRoles.set(JSON.parse(JSON.stringify(localGroupsState.get())));
        saveOrCreateUser(structureContext.id, localUserState.get(), afterSaveCallback)
    }

    const userDialogFooter = (
        <>
            <Button label={I18n.get("Annuler")} icon="pi pi-times" className="p-button-text" onClick={(e) => hideDialog()} />
            <Button label={I18n.get("Sauvegarder")} icon="pi pi-check" className="p-button-text" disabled={localGroupsState.length < 1 || !localUserState.get().given_name || !localUserState.get().family_name || (!targetUser && checkMail())} onClick={saveUser} />
        </>
    );

    const hideDialog = () => {
        setUserDialog(false);
        setMailInUse(false);
        setUsernameInUse(false);
        setActiveIndex(0);
        setTargetStructure();
        setTargetUser();
        localGroupsState.set([]);
        helpState.set({ show: false, help: null })
    }

    const bodySkeletonTemplate = () => {
        return <Skeleton></Skeleton>
    }

    let leftContents = (
        <Button icon="pi pi-user-plus" className="p-mr-2" onClick={(e) => {
            localUserState.set({});
            localGroupsState.set([]);
            setUserDialog(true);
            helpState.set({ help: Help.teammember })
        }} />
    );

    const onCheckChange = (e, localHookState) => {
        if (e.checked) {
            localHookState.merge([e.value]);
        } else {
            localHookState.set(p => {
                p.splice(p.indexOf(e.value), 1);
                return p;
            })
        }
    }

    const checkBoxRoleTemplate = (groups, targetName) => {
        if (groups.length === 0)
            return <></>;
        return (
            <div className="col-12">
                <label><b>{I18n.get(targetName)}</b></label>
                {groups.map((g, itIdx) =>
                    <div className="col-12" key={`divrole${targetName}${itIdx}`}>
                        <Checkbox
                            inputId={`role${targetName}${itIdx}`}
                            name={`role${targetName}${itIdx}`}
                            value={g.id}
                            checked={localGroupsState.get() && localGroupsState.get().includes(g.id)}
                            onChange={(e) => onCheckChange(e, localGroupsState)}
                            className="mr-2"
                        />
                        <label htmlFor={`role${targetName}${itIdx}`}>{I18n.get(g.id)}</label>
                        {g.id === 'delegue' && (<><Tooltip target=".custom-target-icon" />
                            <button
                                type="button"
                                className="custom-target-icon w-1"
                                data-pr-tooltip={I18n.get('delegue_tooltip')}
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2"
                                style={{ fontSize: '1rem', cursor: 'pointer', background: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => helpState.set({ show: true, help: Help.teammember })}
                                aria-label={I18n.get('delegue_tooltip')}
                            >
                                <i className="pi pi-info-circle p-text-secondary" />
                            </button></>)}
                    </div>
                )}
            </div>
        );
    }

    const onStructureChange = (e) => {
        if (e.value) {
            getMyTeam(e.value.id, setMyTargetTeam);
        } else {
            setMyTargetTeam([]);
            setTargetUser();
            localUserState.set({});
            localGroupsState.set([]);
        }
        setTargetStructure(e.value);
    }

    const userOptionTemplate = (option) => {
        return (
            <div>
                <div>{option.given_name} {option.family_name} ({option.Username})</div>
            </div>
        );
    }


    const selectedUserTemplate = (option) => {
        if (option) {
            return (
                <div>
                    <div>{option.given_name} {option.family_name} ({option.Username})</div>
                </div >
            );
        }

        return (
            <span>
                EMPTY
            </span>
        );
    }

    const onTargetUserChange = (e) => {
        setTargetUser(e.value);
        e.value.copyUser = true;
        localUserState.set(e.value);
    }

    const ci = () => {
        return (
            <button
                type="button"
                className="custom-target-icon w-1 mr-4"
                style={{ fontSize: '1rem', cursor: 'pointer', background: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}
                onClick={() => { helpState.set({ show: true, help: Help.teammember }) }}
                aria-label={I18n.get('delegue_tooltip')}
            >
                <i className="pi pi-info-circle" />
            </button>
        );

    };

    return (
        <>
            <ConfirmPopup />
            {!loading && (<>
                <Toolbar left={leftContents} />
                <DataTable emptyMessage=" " size="small" value={myTeam} sortField="family_name" sortOrder={1} responsiveLayout="stack" breakpoint="960px">
                    <Column
                        field="Username"
                        header={I18n.get("Nom d'utilisateur")}
                        style={{ width: "12em" }}
                        sortable
                    />
                    <Column
                        field="family_name"
                        header={I18n.get("Nom")}
                        sortable
                    />
                    <Column
                        field="given_name"
                        header={I18n.get("Prénom")}
                        sortable
                    />
                    <Column
                        field="Enabled"
                        header={I18n.get("Statut")}
                        body={statusBodyTemplate}
                        style={{ width: "8em" }}
                        sortable
                    />

                    <Column
                        header={I18n.get("Rôles")}
                        body={autoBodyTemplate}
                    />

                    <Column body={actionBodyTemplate} exportable={false} style={{ width: '10em' }}></Column>
                </DataTable>

                <Dialog icons={ci} visible={userDialog} style={{ width: '450px' }} header={localUserState.get().Username ? `${localUserState.get().family_name} ${localUserState.get().given_name}` : I18n.get('Nouvel utilisateur')} modal className="p-fluid" footer={userDialogFooter} onHide={hideDialog}>
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header={I18n.get("Informations personnelles")} leftIcon="pi pi-user cdm-icon-tab">
                            {(targetUser || (structures.length > 1 && !localUserState.get().sub && !localUserState.get().given_name && !localUserState.get().family_name && !localUserState.get().email)) && (<>
                                <div className="grid">
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <Dropdown
                                                onChange={onStructureChange}
                                                value={targetStructure}
                                                options={structures.filter(s => s.id !== structureContext.id)}
                                                optionLabel="name"
                                                name='existingstructure'
                                                showClear />
                                            <label htmlFor="existingstructure">{I18n.get("Vos entreprises")}</label>
                                        </span>
                                    </div>

                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <Dropdown
                                                options={myTargetTeam.filter(tgt => !myTeam.find(t => t.sub === tgt.sub)).sort((a, b) => ((a.given_name + a.family_name) > (b.given_name + b.family_name)) ? 1 : (((b.given_name + b.family_name) > (a.given_name + a.family_name)) ? -1 : 0))}
                                                optionLabel="Username"
                                                itemTemplate={userOptionTemplate}
                                                valueTemplate={selectedUserTemplate}
                                                value={targetUser}
                                                onChange={onTargetUserChange}
                                                name='existinguser'
                                                emptyMessage={!targetStructure ? I18n.get("Merci de sélectionner une entreprise") : I18n.get("Tous les utilisteurs ont accès")}
                                            />
                                            <label htmlFor="existinguser">{I18n.get("Utilisateur")}</label>
                                        </span>
                                    </div>

                                </div>
                                {!targetStructure && (<Divider align="center">
                                    <b>{I18n.get("Ou")}</b>
                                </Divider>)}
                            </>)}
                            {!targetStructure && (<div className="grid">
                                {(localUserState.get().sub || usernameInUse) && (<div className="col-12" style={{ marginTop: '10px' }}><span className="p-float-label cdm-float-label">
                                    <InputText
                                        id="username"
                                        name='Username'
                                        required
                                        autoFocus
                                        disabled={localUserState.get().sub}
                                        value={localUserState.get().Username || ''}
                                        onChange={(e) => onChange(e)}
                                        keyfilter="alpha"
                                    />
                                    <label htmlFor="username">{I18n.get("Nom d'utilisateur")}</label>
                                    {usernameInUse && (<small id="username-help" className="p-error block">{I18n.get("Nom d'utilisateur déjà attribué")}</small>)}
                                </span></div>)}

                                <div className="col-12">
                                    <span className="p-float-label cdm-float-label">
                                        <InputText
                                            id="family_name"
                                            name="family_name"
                                            value={localUserState.get().family_name || ''}
                                            onChange={(e) => onChange(e)}
                                            required
                                            className={classNames({
                                                "cdm-field-error": !localUserState.get().family_name,
                                            })} />
                                        <label htmlFor="family_name">{I18n.get("Nom")}</label>
                                    </span>

                                </div>
                                <div className="col-12">
                                    <span className="p-float-label cdm-float-label">
                                        <InputText
                                            id="given_name"
                                            name="given_name"
                                            value={localUserState.get().given_name || ''}
                                            onChange={(e) => onChange(e)}
                                            required
                                            className={classNames({
                                                "cdm-field-error": !localUserState.get().given_name,
                                            })} />
                                        <label htmlFor="given_name">{I18n.get("Prénom")}</label>
                                    </span>
                                </div>
                                <div className="col-12">
                                    <span className="p-float-label cdm-float-label">
                                        <InputText
                                            name="phone_number"
                                            id="phone_number"
                                            type="text"
                                            value={localUserState.get().phone_number ?? ''}
                                            onChange={(e) => onChange(e)}
                                            size={25}
                                            className={classNames({
                                                "cdm-field-error": (checkPhoneNumber(localUserState.get().phone_number)),
                                            })}
                                            placeholder="+352123456"
                                        />
                                        <label htmlFor="phone_number">{I18n.get("phone_number")}</label>
                                    </span>
                                    {checkPhoneNumber(localUserState.get().phone_number) && (
                                        <small id="phone-help" className="p-error block pt-2">{I18n.get("invalideFormat")}</small>
                                    )}
                                </div>
                                <div className="col-12">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText
                                                id="email"
                                                name="email"
                                                value={localUserState.get().email || ''}
                                                onChange={(e) => onChange(e)}
                                                className={classNames({
                                                    "cdm-field-error": checkMail() || mailInUse,
                                                })}
                                                disabled={localUserState.get().UserStatus === 'CONFIRMED' || localUserState.get().UserStatus === 'ARCHIVED'} />
                                            <label htmlFor="email">{I18n.get("eMail")}</label>
                                        </span>
                                        <span className="p-inputgroup-addon cdm-float-label">
                                            <i className="fas fa-at"></i>
                                        </span>
                                    </div>
                                    {mailInUse && (<small id="email-help" className="p-error block">{I18n.get("Email déjà utilisé")}</small>)}
                                </div>
                                <div className="col-12">
                                    <span className="p-float-label cdm-float-label">
                                        <Dropdown
                                            id="locale"
                                            value={localUserState.get().locale || 'FR'}
                                            options={[{ label: 'Allemand', value: 'DE' }, { label: 'Français', value: 'FR' }]}
                                            onChange={(e) => onChange(e)}
                                            name="locale" />
                                        <label htmlFor="locale">{I18n.get("Langue préférée")}</label>
                                    </span>
                                </div>
                            </div>)}
                        </TabPanel>
                        <TabPanel header={I18n.get("Permissions")} leftIcon="fas fa-key cdm-icon-tab">
                            <div className="grid">
                                {isGerant && checkBoxRoleTemplate(groupsGeneriques, I18n.get('Génériques'))}
                                {checkBoxRoleTemplate(groupsApprentissage, I18n.get('Apprentissage'))}
                                {checkBoxRoleTemplate(groupsScrb, I18n.get('SCRB'))}
                            </div>
                        </TabPanel>
                    </TabView>

                </Dialog></>)}

            {loading && (<DataTable emptyMessage=" " value={dummyTeam} size="small" responsiveLayout="stack" breakpoint="960px">
                <Column
                    field="Username"
                    header={I18n.get("Nom d'utilisateur")}
                    style={{ width: "12em" }}
                    sortable
                    body={bodySkeletonTemplate}
                />
                <Column
                    field="family_name"
                    header={I18n.get("Nom")}
                    sortable
                    body={bodySkeletonTemplate}
                />
                <Column
                    field="given_name"
                    header={I18n.get("Prénom")}
                    sortable
                    body={bodySkeletonTemplate}
                />
                <Column
                    field="Enabled"
                    header={I18n.get("Statut")}
                    body={bodySkeletonTemplate}
                    style={{ width: "8em" }}
                    sortable
                />

                <Column
                    header={I18n.get("Rôles")}
                    body={bodySkeletonTemplate}
                />

                <Column body={bodySkeletonTemplate} style={{ width: '10em' }}></Column>
            </DataTable>
            )}
        </>
    );
}